// import App from '../../App.css'
import { useState } from 'react'

const Todo = () => {

    const [todo, setTodo] = useState('')
    const [arr, setArr] = useState([])
    const [edit, setEdit] = useState(false)
    // const [updateData, setUpdate] = useState()
    const [indexData, setIndex] = useState()

    const onKeyPress = (e) => {
        if (e?.charCode === 13) {
            console.log('Im entered pressed dear!');
            if (!todo.length) {
                alert('Empty')
            } else {
                arr.push(todo)
                setArr(arr)
                setTodo('')
            }
        }
    }

    const onChange = (e) => {
        setTodo(e?.target?.value)
    }

    const Add = () => {
        if (!todo.length) {
            alert('Bro')
        } else {
            arr.push(todo)
            setArr(arr)
            setTodo('')
        }
    }

    const editData = (index) => {
        setTodo(arr[index])
        setEdit(true)
        setIndex(index)
    }

    const deleteData = (index) => {
        arr.splice(index, 1)
        setArr([...arr])
        Cancel()
    }

    const Update = () => {
        arr[indexData] = todo
        setArr([...arr])
        setTodo('')
        setEdit(false)
        setIndex(null)
    }

    const Cancel = () => {
        setTodo('')
        setEdit(false)
    }

    return (
        <div>
            <input
                placeholder="Enter your todo here!"
                onKeyPress={onKeyPress}
                autoFocus
                onChange={onChange}
                value={todo}
            />
            {!edit ?
                <button onClick={Add}>Add</button> :
                <span>
                    <button onClick={Update}>Update</button>
                    <button onClick={Cancel}>Cancel</button>
                </span>
            }
            <ol>
                {arr.map((v, i) => {
                    return (
                        <li key={i}>{v}&nbsp;
                            <button onClick={() => editData(i)}>Edit</button> &nbsp;
                            <button onClick={() => deleteData(i)}>Delete</button></li>
                    )
                })}
            </ol>
        </div >
    )
};

export default Todo;
